import { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getChildren, getDomesticPartners } from '../../../global/ducks/person-prc-api';
import { DemographicsContext } from '../../../global/models/demographics-model';
import { TcsmStates } from '../../../root/tcsm-model';
import { DependentsState } from '../features/dependents/dependents-model';
import { dispatchSetChildren, dispatchSetChildrenFailed, dispatchSetDomesticPartners, dispatchSetDomesticPartnersFailed } from '../features/dependents/dependents-slice';

export function useDependents(guid: string) {
    const dispatch = useDispatch();
    const app = useContext(DemographicsContext);
    const dependentsState = useSelector<TcsmStates, DependentsState>(state => state.dependents[app]);

    useEffect(() => {
        if (guid) {
            if (!dependentsState.childrenFetched) {
                dispatch(getChildren(guid, dispatchSetChildren(dispatch, app), () => dispatchSetChildrenFailed(dispatch, app)));
            }
            if (!dependentsState.domesticPartnersFetched) {
                dispatch(getDomesticPartners(guid, dispatchSetDomesticPartners(dispatch, app), () => dispatchSetDomesticPartnersFailed(dispatch, app)));
            }
        }
    }, [guid]);


    return guid && dependentsState.childrenFetched && dependentsState.domesticPartnersFetched && dependentsState.loadingDependentPersons === 0;
}